import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Hero } from '../components/home/Hero';
import { WhyChoose } from '../components/home/WhyChoose';
import { ServicesShowcase } from '../components/home/ServicesShowcase';
import { GalleryPreview } from '../components/home/GalleryPreview';
import { ProcessSection } from '../components/home/ProcessSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { BilingualSection } from '../components/home/BilingualSection';
import { ServiceAreaSection } from '../components/home/ServiceAreaSection';
import { CtaSection } from '../components/CtaSection';
import { FaqAccordion } from '../components/FaqAccordion';
import { SectionHeading } from '../components/SectionHeading';
import { LeadForm } from '../components/LeadForm';
import { faqs } from '../data/faqs';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeo } from '../hooks/useSeo';
import { buttonClass } from '../utils/styles';
export function Home() {
  const {
    t,
    lang
  } = useLanguage();
  useSeo({
    title: lang === 'en' ? 'Professional Painting, Drywall & Flooring Services Dallas TX | M&S Multiservices' : 'Pintura, Drywall y Pisos Profesionales en Dallas TX | M&S Multiservices',
    description: lang === 'en' ? 'Licensed & insured painting, drywall, flooring and remodeling contractor in Dallas-Fort Worth. 10+ years, family owned, bilingual service, free estimates. Call +1 (214) 259-5582.' : 'Contratista de pintura, drywall, pisos y remodelación en Dallas-Fort Worth. Con licencia y seguro, 10+ años, negocio familiar, servicio bilingüe y presupuestos gratis. Llama al +1 (214) 259-5582.'
  });
  return <>
      <Hero data-id="element-478" data-mp="2376la76k4bzy" />
      <WhyChoose data-id="element-479" data-mp="1z763qdo5vkoo" />
      <ServicesShowcase data-id="element-480" data-mp="1z7pdh73nr2rm" />
      <GalleryPreview data-id="element-481" data-mp="1z6wdcoz7fbig" />
      <ProcessSection data-id="element-482" data-mp="1z9ii6gupncwz" />
      <TestimonialsSection data-id="element-483" data-mp="1u8l3ie8wt108" />
      <BilingualSection data-id="element-484" data-mp="1u9e2gt1mmm7t" />

      <section className="bg-white" aria-labelledby="home-form-heading" data-id="element-485" data-mp="1u8uspzm4r44v">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24" data-id="element-486" data-mp="1kjnvj5be47xi">
          <div className="grid gap-10 lg:grid-cols-[1fr_1.05fr] lg:gap-16" data-id="element-487" data-mp="1om2fxtupjfqw">
            <div data-id="element-488" data-mp="1ok7wkjz33vox">
              <SectionHeading id="home-form-heading" eyebrow={t({
              en: 'Common questions',
              es: 'Preguntas frecuentes'
            })} title={t({
              en: 'Straight answers before you commit',
              es: 'Respuestas claras antes de decidir'
            })} data-id="element-489" data-mp="1amjbbb13umjc" />
              <div className="mt-8" data-id="element-490" data-mp="2899w9x7euv7m">
                <FaqAccordion items={faqs.slice(0, 5)} data-id="element-491" data-mp="28ce5j8zqgh55" />
              </div>
              <Link to="/faq" className={buttonClass('outline', 'md', 'mt-8')} data-id="element-492" data-mp="1tkvvdrtk1gtp">
                {t({
                en: 'Read all FAQs',
                es: 'Ver todas las preguntas'
              })}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-493" data-mp="2macge4euhvfw" />
              </Link>
            </div>
            <div className="lg:pt-4" data-id="element-494" data-mp="2r12ohpenocea">
              <LeadForm data-id="element-495" data-mp="2r240bw3hx2x2" />
            </div>
          </div>
        </div>
      </section>

      <ServiceAreaSection data-id="element-496" data-mp="fkiw4xrr2mo2" />
      <CtaSection data-id="element-497" data-mp="fjpnfr98dn3a" />
    </>;
}